import type { Product } from "@jasper/client-models";

const byAscending = (first: number, second: number) => first - second;

const byFirstTooth = (first: Product, second: Product) =>
  (first.teeth[0] ?? 0) - (second.teeth[0] ?? 0);

/** Every tooth of the group, in ascending order. */
export const getGroupTeeth = (products: ReadonlyArray<Product>): number[] =>
  products.flatMap(product => [...product.teeth]).sort(byAscending);

export const sortByFirstTooth = <TProduct extends Product>(
  products: ReadonlyArray<TProduct>
): TProduct[] => [...products].sort(byFirstTooth);
